export default __webpack_public_path__ + "static/media/bus126.df698de0.svg";